import React, { useEffect, useState } from 'react';
import { message, Col, Row, Button, Table, Spin, Tooltip } from 'antd';
import { useParams } from 'react-router-dom';
import { getQualityBaseInfo, getQualityDetail } from './api';
import { baseInfo, formatType, isPureNumber, } from './default';
import moment from 'moment';
import { deepClone, createPDF } from '../../util/tool';
import { InfoCircleOutlined } from '@ant-design/icons';

function Index(props) {
  const { list = [], type = '', style = {} } = props;
  return (
    <>
      {(list || []).length ? <div className='media-print-container'>
        {(list || []).map((item, index) => <div className='media-container-item' key={index}>
          {(type === 'image') && <img className='port-quality-report-item-img' src={item.url} alt='' style={style} />}
          {(type === 'video') && <video className='port-quality-report-item-img' style={style}><source src={item.url.replace(/http:\/\//, 'https://')} /></video>}
        </div>)}
      </div> : null}
    </>
  );
}

export default function WarehouseQualityPrint() {
  const { order_id, quality_id, type } = useParams();
  const [info, setInfo] = useState(deepClone(baseInfo));
  const [loading, setLoading] = useState(false);
  const [btn, setBtn] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [qualityBaseInfo, setQualityBaseInfo] = useState({});
  const [computedSource, setComputedSource] = useState({});
  
  const computed_data_source = (data) => {
    const len = (data || []).length;
    const standard_numbers = (data || []).reduce((pre, next) => pre + Number(next.standard_number), 0);
    const standard_numbers_check = len ? (data || []).every(item => isPureNumber(item.standard_number)) : false;
    const actual_numbers_check = len ? (data || []).every(item => isPureNumber(item.actual_number)) : false;
    const actual_numbers = actual_numbers_check ? (data || []).reduce((pre, next) => pre + Number(next.actual_number || 0), 0) : '';
    const deviation = standard_numbers_check && actual_numbers_check ? (data || []).reduce((pre, next) => pre + (Number(next.actual_number || 0) - Number(next.standard_number || 0)), 0) + '箱' : '';
    setComputedSource({ standard_numbers, standard_numbers_check, actual_numbers_check, actual_numbers, deviation }); //合计
  };

  useEffect(() => {
    try {
      (async () => {
        async function getQualityBase() {
          let company_id = window.localStorage.getItem('companyId');
          let user_id = window.localStorage.getItem('user_id');
          return new Promise(async (resolve) => {
            const { data: { code, msg, data } } = await getQualityBaseInfo(({ order_no: order_id, company_id, user_id }));
            if (+code === 0) {
              setQualityBaseInfo(data);
              const { product_info = [] } = data;
              const processedProductInfo = (product_info || []).map(item => {
                return {
                  ...item,
                  standard_number: item.standard_number || item.deliver_number,
                  actual_number: item.actual_number || item.receive_number
                };
              });
              setDataSource([...processedProductInfo]);
              computed_data_source([...processedProductInfo]);
            } else {
              message.error(msg);
            }
            resolve();
          });
        }
        async function getQualityDetailInfo() {
          return new Promise(async (resolve) => {
            let company_id = window.localStorage.getItem('companyId');
            let user_id = window.localStorage.getItem('user_id');
            const { data: { code, msg, data } } = await getQualityDetail(({ quality_no: quality_id, company_id, user_id }));
            if (+code === 0) {
              setInfo({ ...data });
              setDataSource(data?.product_info || []);
              computed_data_source(data?.product_info || []);
            } else {
              message.error(msg);
            }
            resolve();
          });
        }
        await getQualityBase();
        await getQualityDetailInfo();
      })();
    } finally {
      setLoading(true);
      const timer = setTimeout(() => {
        setBtn(true);
        clearTimeout(timer);
      }, 3000);
    }
    // return setInfo({ ...deepClone(baseInfo) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_id, quality_id, type]);

  const showModal = () => { };
  const columns = [
    {
      title: '商品名称',
      dataIndex: 'name',
      key: 'name',
      width: 300
    },
    {
      title: '单位重量(kg)',
      dataIndex: 'base_factor',
      key: 'base_factor',
      width: 100
    },
    {
      title: '标准到货',
      dataIndex: 'standard_number',
      key: 'standard_number',
      width: 200,
      render: (text, record, index) => {
        const { standard_number } = record;
        return <>{standard_number}</>;
      }
    },
    {
      title: '占比',
      dataIndex: 'standard_percent',
      key: 'standard_percent',
      width: 100,
      render: (text, record) => {
        const { standard_number } = record;
        if (isPureNumber(standard_number)) {
          const total = dataSource.reduce((pre, next) => {
            const num = next.standard_number;
            return pre + (isPureNumber(num) ? Number(num) : 0);
          }, 0);
          const current_percent = parseFloat(standard_number / total) * 100;
          return isPureNumber(current_percent) && total ? current_percent.toFixed(2) + '%' : '';
        } else {
          return '';
        }
      }
    },
    {
      title: '实际到货',
      dataIndex: 'actual_number',
      key: 'actual_number',
      width: 200,
      render: (text, record, index) => {
        const { actual_number } = record;
        return <>{actual_number }</>;
      }
    },
    {
      title: '占比',
      width: 100,
      dataIndex: 'actual_percent',
      key: 'actual_percent',
      render: (text, record) => {
        const { actual_number } = record;
        if (isPureNumber(actual_number)) {
          const total = dataSource.reduce((pre, next) => {
            const num = next.actual_number;
            return pre + (isPureNumber(num) ? Number(num) : 0);
          }, 0);
          const current_percent = parseFloat(actual_number / total) * 100;
          return isPureNumber(current_percent) && total ? current_percent.toFixed(2) + '%' : '';
        } else {
          return '';
        }
      }
    },
    {
      title: '偏差',
      width: 100,
      dataIndex: 'deviation',
      key: 'deviation',
      render: (text, record, index) => {
        const { standard_number, actual_number } = record;
        return isPureNumber(actual_number) && isPureNumber(standard_number) ? `${(actual_number || 0) - (standard_number || 0)}箱` : '';
      }
    },
  ];
  const columns2 = [
    {
      title: '商品名称',
      dataIndex: 'name',
      key: 'name',
      width: 300
    },
    {
      title: '抽检数量',
      dataIndex: 'sample_number',
      key: 'sample_number',
      render: (text, record, index) => {
        return <>{text}箱</>;
      }
    },
    {
      title: '占比',
      width: 300,
      dataIndex: 'sample_percent',
      key: 'sample_percent',
      render: (text, record) => {
        const { sample_number } = record;
        if (isPureNumber(sample_number)) {
          const total = dataSource.reduce((pre, acc) => pre + acc.sample_number, 0);
          const current_percent = sample_number * 100 / total;
          return isPureNumber(current_percent) ? current_percent.toFixed(2) + '%' : '';
        } else {
          return '';
        }
      }
    },
  ];
  const columns3 = [
    {
      title: '柜位置',
      dataIndex: 'position',
      key: 'position'
    },
    {
      title: '称重数量(箱数)',
      dataIndex: 'single_weight_container_number',
      key: 'single_weight_container_number'
    },
    {
      title: '称重(kg)',
      dataIndex: 'weight_info',
      key: 'weight_info',
      render: (text, record, posIdx) => {
        return (
          <div>
            {record?.single_data?.map((data, dataIdx) => (
              <div key={dataIdx} style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ minWidth: 80, fontWeight: 'bold' }}>{data?.single_weight_number || '-'}</span>
                {(data?.single_weight_pic || []).length ? (
                  <div style={{ width: 50, height: 50 }}>
                    <Index style={{ width: 50, height: 50 }} list={data?.single_weight_pic || []} type='image' preview={showModal} edit={false} />
                  </div>
                ) : (
                  <span style={{ color: '#999' }}>无图片</span>
                )}
              </div>
            ))}
          </div>
        );
      }
    },
    {
      title: '平均毛重(kg)',
      dataIndex: 'average_gross_weight',
      key: 'average_gross_weight',
      render: (text) => text || '-'
    },
    {
      title: '包装重量(kg)',
      dataIndex: 'package_weight',
      key: 'package_weight',
      render: (text) => text || '-'
    },
    {
      title: '平均净重(kg)',
      dataIndex: 'average_net_weight',
      key: 'average_net_weight',
      render: (text) => text || '-'
    },
    {
      title: '偏差占比',
      dataIndex: 'deviation_proportion',
      key: 'deviation_proportion',
      render: (text) => text || '-'
    },
    {
      title: <>
        是否达标
        <Tooltip title="实际净重小于标准值被视为不合格；重量实际净重大于等于标准值则视为合格">
          <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'help' }} />
        </Tooltip>
      </>,
      dataIndex: 'is_standard',
      key: 'is_standard',
      render: (text) => text || '-'
    }
  ];
  // const average_weight = (info?.weight_info?.average_weight || 0);
  // const package_weight = (info?.weight_info?.package_weight || 0);
  // const average_net_weight = accSub(average_weight, package_weight);
  // const weight_deviation_calc = accSub(average_net_weight, standardWeight);
  // const weight_deviation = !isNaN(+weight_deviation_calc) ? (+weight_deviation_calc).toFixed(2) : '';
  // const weight_deviation_percent = (weight_deviation * 100 / standardWeight).toFixed(2);
  const total_number = info?.sample_info?.total_number;
  const poor_fruit_shape_number_percent = isPureNumber(total_number) && isPureNumber(info?.fruit_shape?.poor_fruit_shape_number) && (info?.fruit_shape?.poor_fruit_shape_number * 100 / total_number).toFixed(2);
  const red_thorn_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.colour_info?.red_thorn_fruit) && (info?.colour_info?.red_thorn_fruit * 100 / total_number).toFixed(2);
  const brown_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.colour_info?.brown_fruit) && (info?.colour_info?.brown_fruit * 100 / total_number).toFixed(2);
  const whole_green_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.colour_info?.whole_green_fruit) && (info?.colour_info?.whole_green_fruit * 100 / total_number).toFixed(2);
  const other_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.colour_info?.other_fruit) && (info?.colour_info?.other_fruit * 100 / total_number).toFixed(2);
  const bear_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.shuck_info?.bear_fruit) && (info?.shuck_info?.bear_fruit * 100 / total_number).toFixed(2);
  const dead_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.shuck_info?.dead_fruit) && (info?.shuck_info?.dead_fruit * 100 / total_number).toFixed(2);
  // const durian_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.shuck_info?.durian_fruit) && (info?.shuck_info?.durian_fruit * 100 / total_number).toFixed(2);
  // const damage_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.shuck_info?.damage_fruit) && (info?.shuck_info?.damage_fruit * 100 / total_number).toFixed(2);
  const wormhole_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.shuck_info?.wormhole_fruit) && (info?.shuck_info?.wormhole_fruit * 100 / total_number).toFixed(2);
  const rotten_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.shuck_info?.rotten_fruit) && (info?.shuck_info?.rotten_fruit * 100 / total_number).toFixed(2);
  const shuck_other_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.shuck_info?.shuck_other_fruit) && (info?.shuck_info?.shuck_other_fruit * 100 / total_number).toFixed(2);
  // const cleft_fruit_percent = isPureNumber(total_number) && isPureNumber(info?.shuck_info?.cleft_fruit) && (info?.shuck_info?.cleft_fruit * 100 / total_number).toFixed(2);
  const sample_number_percent = computedSource?.actual_numbers_check ? ((info?.sample_info?.sample_number * 100 / computedSource?.actual_numbers).toFixed(2) + '%') : " ";
  const { container_info: { container_temperature_head, container_temperature_middle, container_temperature_end, core_temperature1, core_temperature2, core_temperature3 } = {},
    colour_info: { red_thorn_fruit, brown_fruit, whole_green_fruit, other_fruit, fruit_color_1, fruit_color_2, fruit_color_3, fruit_color_4 } = {},
    shuck_info: { fruit_flesh_rot, fruit_flesh_blight, fruit_flesh_wormy, fruit_flesh_burning, cleft_fruit_low, cleft_fruit_middle, cleft_fruit_high, shuck_other_fruit, wormhole_fruit, rotten_fruit } = {},
    fruit_shape: { fruit_house_number, fruit_house_number_35, fruit_house_number_3, fruit_house_number_4 },
    flesh_info: { sugar_sampling1, sugar_sampling2, sugar_sampling3 } = {}
  } = info;
  const fruit_house_number_percent = isPureNumber(total_number) && isPureNumber(fruit_house_number) && (fruit_house_number * 100 / total_number).toFixed(2);
  const fruit_house_number_3_percent = isPureNumber(total_number) && isPureNumber(fruit_house_number_3) && (fruit_house_number_3 * 100 / total_number).toFixed(2);
  const fruit_house_number_35_percent = isPureNumber(total_number) && isPureNumber(fruit_house_number_35) && (fruit_house_number_35 * 100 / total_number).toFixed(2);
  const fruit_house_number_4_percent = isPureNumber(total_number) && isPureNumber(fruit_house_number_4) && (fruit_house_number_4 * 100 / total_number).toFixed(2);
  const computed_shuck_other_fruit_number = () => {//发霉总计
    const total = (Number(wormhole_fruit) || 0) + (Number(rotten_fruit) || 0) + (Number(shuck_other_fruit) || 0);
    return Number(total.toFixed(2));
  };
  const computed_container_temperature_average = () => { // 柜头，中，尾 平均温度
    const head = isPureNumber(container_temperature_head);
    const middle = isPureNumber(container_temperature_middle);
    const end = isPureNumber(container_temperature_end);
    const isValid = (num) => !isNaN(num) && isFinite(num);
    const validNums = [head, middle, end].filter(isValid);
    if (validNums.length === 0) {
      return '';
    }
    const sum = validNums.reduce((total, num) => total + num, 0);
    const average = sum / validNums.length;
    return average;
  };
  const computed_fruit_stalk_number = () => {//果柄合计
    const broken = Number(info?.fruit_stalk?.fruit_stalk_broken) || 0;
    const lacking = Number(info?.fruit_stalk?.fruit_stalk_lacking) || 0;
    const rotten = Number(info?.fruit_stalk?.fruit_stalk_rotten) || 0;
    const total = broken + lacking + rotten;
    if (total > 100) {
      message.warning('果柄各类问题百分比合计超过100%，请检查数值！');
    }
    return Number(total.toFixed(2));
  };

  // 添加果柄相关占比方法
  const computed_fruit_stalk_broken_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(info?.fruit_stalk?.fruit_stalk_broken) && Number(info?.fruit_stalk?.fruit_stalk_broken) > 0) {
      return (Number(info?.fruit_stalk?.fruit_stalk_broken) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_stalk_lacking_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(info?.fruit_stalk?.fruit_stalk_lacking) && Number(info?.fruit_stalk?.fruit_stalk_lacking) > 0) {
      return (Number(info?.fruit_stalk?.fruit_stalk_lacking) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_stalk_rotten_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(info?.fruit_stalk?.fruit_stalk_rotten) && Number(info?.fruit_stalk?.fruit_stalk_rotten) > 0) {
      return (Number(info?.fruit_stalk?.fruit_stalk_rotten) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_stalk_number_percent = () => {
    const total = computed_fruit_stalk_number();
    if (isPureNumber(total_number) && total > 0) {
      return (total * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_peel_number = () => {//果皮缺陷合计
    const red = isPureNumber(red_thorn_fruit) ? Number(red_thorn_fruit) : 0;
    const brown = isPureNumber(brown_fruit) ? Number(brown_fruit) : 0;
    const green = isPureNumber(whole_green_fruit) ? Number(whole_green_fruit) : 0;
    const other = isPureNumber(other_fruit) ? Number(other_fruit) : 0;
    const total = red + brown + green + other;
    if (total > 100) {
      message.warning('果皮缺陷各类问题百分比合计超过100%，请检查数值！');
    }
    return isPureNumber(total) ? Number(total.toFixed(2)) : "";
  };

  const computed_fruit_peel_number_percent = () => {
    const total = computed_fruit_peel_number();
    if (isPureNumber(total_number) && total > 0) {
      return (total * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_core_temperature_average = () => {// 果心平均温度
    const core_1 = isPureNumber(core_temperature1) ? Number(core_temperature1) : 0;
    const core_2 = isPureNumber(core_temperature2) ? Number(core_temperature2) : 0;
    const core_3 = isPureNumber(core_temperature3) ? Number(core_temperature3) : 0;
    const isValid = (num) => !isNaN(num) && isFinite(num);
    const validNums = [core_1, core_2, core_3].filter(isValid);
    if (validNums.length === 0) {
      return '';
    }
    const sum = validNums.reduce((total, num) => total + num, 0);
    const average = sum / validNums.length;
    return average;
  };
  const computed_fruit_flesh_number = () => {//果肉问题总计
    const total = (Number(fruit_flesh_rot) || 0) + (Number(fruit_flesh_blight) || 0) + (Number(fruit_flesh_wormy) || 0) + (Number(fruit_flesh_burning) || 0);
    return Number(total.toFixed(2));
  };
  const computed_cleft_fruit_number = () => {//开裂总计
    const total = (Number(cleft_fruit_low) || 0) + (Number(cleft_fruit_middle) || 0) + (Number(cleft_fruit_high) || 0);
    return Number(total.toFixed(2));
  };
  // 添加果壳其他问题合计占比函数
  const computed_shuck_other_fruit_number_percent = () => {
    const total = computed_shuck_other_fruit_number();
    if (isPureNumber(total_number) && total > 0) {
      return (total * 100 / total_number).toFixed(2);
    }
    return '';
  };
  // 添加开裂合计占比函数
  const computed_cleft_fruit_number_percent = () => {
    const total = computed_cleft_fruit_number();
    if (isPureNumber(total_number) && total > 0) {
      return (total * 100 / total_number).toFixed(2);
    }
    return '';
  };

  // 添加平均糖度计算函数
  const computed_average_sugar = () => {
    const sugars = [sugar_sampling1, sugar_sampling2, sugar_sampling3].filter(s => isPureNumber(s));
    if (sugars.length > 0) {
      const sum = sugars.reduce((acc, s) => acc + Number(s), 0);
      return (sum / sugars.length).toFixed(2);
    }
    return '';
  };

  // 添加颜色占比计算函数
  const computed_fruit_color_1_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(fruit_color_1) && Number(fruit_color_1) > 0) {
      return (Number(fruit_color_1) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_color_2_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(fruit_color_2) && Number(fruit_color_2) > 0) {
      return (Number(fruit_color_2) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_color_3_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(fruit_color_3) && Number(fruit_color_3) > 0) {
      return (Number(fruit_color_3) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_color_4_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(fruit_color_4) && Number(fruit_color_4) > 0) {
      return (Number(fruit_color_4) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  // 添加果肉问题占比计算函数
  const computed_fruit_flesh_rot_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(fruit_flesh_rot) && Number(fruit_flesh_rot) > 0) {
      return (Number(fruit_flesh_rot) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_flesh_blight_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(fruit_flesh_blight) && Number(fruit_flesh_blight) > 0) {
      return (Number(fruit_flesh_blight) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_flesh_wormy_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(fruit_flesh_wormy) && Number(fruit_flesh_wormy) > 0) {
      return (Number(fruit_flesh_wormy) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  const computed_fruit_flesh_burning_percent = () => {
    if (isPureNumber(total_number) && isPureNumber(fruit_flesh_burning) && Number(fruit_flesh_burning) > 0) {
      return (Number(fruit_flesh_burning) * 100 / total_number).toFixed(2);
    }
    return '';
  };

  // const computed_shuck_other_fruit_number_percent = () => base_computed('shuck_other_fruit_number_percent', computed_shuck_other_fruit_number(), total_number_computed);

  const title = `订单${order_id}-柜号${info?.container_no}大仓质检记录`;
  const createPdfMethod = async () => {
    // let doc = document.querySelector('html').cloneNode(true);
    // console.log(doc.querySelector('#root').remove());
    // doc.querySelector('body').appendChild(document.querySelector('.port-quality-report-warehouse-base').cloneNode(true));
    // const Iframe = document.createElement('iframe');
    // Iframe.appendChild(document.querySelector('html').cloneNode(true));
    // Iframe.querySelector("#root").innerHTML = '';
    // Iframe.querySelector("#root").appendChild(document.querySelector('.port-quality-report-warehouse-base').cloneNode(true));
    // await createPDF({ fileName: `${title}.pdf`, content: Iframe.innerHTML });
    await createPDF({ fileName: `${title}.pdf`, url: window.location.href });
  };
  const SugarSamplingDisplay = ( info, showModal ) => {
    const sugarType = info?.flesh_info?.sugar_sampling_type ?? 0;
    const sugarConfig = [
      { label: '糖度1', key: 'sugar_sampling1', picKey: 'sugar_sampling1_pic' },
      { label: '糖度2', key: 'sugar_sampling2', picKey: 'sugar_sampling2_pic' },
      { label: '糖度3', key: 'sugar_sampling3', picKey: 'sugar_sampling3_pic' },
    ];
    return (
      <div>
        {sugarConfig.map((item, index) => {
          const shouldShow = index === 0 ? sugarType >= 1
            : index === 1 ? sugarType >= 2
              : sugarType > 2;

          if (!shouldShow) return null;

          return (
            <Row key={item.key}>
              <Col span={8}>
                <span>{item.label}:</span>
                <span>{info?.flesh_info?.[item.key] ?? '-'}</span>%Brix
                <Index
                list={info?.flesh_info?.[item.picKey] || []}
                type='image'
                preview={showModal}
              />
              </Col>
            </Row>
          );
        })}
      </div>
    );
  };
  return (
    <div className='quality-report-container quality-print-base-container' style={{ pageBreakBefore: 'awlays' }}>
      {
        loading ? <>
          {btn ? <Button style={{ position: 'fixed', top: '48vh', right: 0, zIndex: 1 }} type='primary' onClick={createPdfMethod}>下载</Button> : null}
          <div className='port-quality-report-base port-quality-report-warehouse-base' style={{ padding: 50 }}>
            <div style={{ textAlign: 'center' }}>
              <b className='title' style={{ fontSize: 24, }}>{title}</b>
            </div>
            <div className='quality-report-title'>到货基本信息</div>
            <Row>
              <Col span={7}><span>柜号:</span><span>{info?.container_no}</span></Col>
              <Col span={7}><span>到货时间:</span><span>{info?.base_info?.arrival_time && moment(info?.base_info?.arrival_time).format(formatType)}</span></Col>
              <Col span={7}><span>质检时间:</span><span>{info?.base_info?.quality_time && moment(info?.base_info?.quality_time).format(formatType)}</span></Col>
            </Row>
            <Row>
              <Col span={7}><span>汽车车牌号:</span><span>{info?.base_info?.car_number}</span> <Index list={info?.base_info?.car_number_pic || []} type='image' preview={showModal} /></Col>
              <Col span={7}><span>汽车车型:</span><span>{info?.base_info?.car_type}</span></Col>
            </Row>
            <Row>
              <Col span={7}><span>驾驶证:</span><span>{info?.base_info?.driver_license}</span><Index list={info?.base_info?.driver_license_pic || []} type='image' preview={showModal} /></Col>
              <Col span={7}><span>驾驶员姓名:</span><span>{info?.base_info?.driver_name}</span></Col>
              <Col span={7}><span>驾驶员电话:</span><span>{info?.base_info?.driver_number}</span></Col>
            </Row>
            <Row>
              <Col span={16}><span>到货地:</span><span>{(qualityBaseInfo?.address_list || []).find(item => +item.id === +info?.base_info?.address_id)?.address}</span></Col>
              <Col span={7}><span>环境温度:</span><span>{info?.base_info?.temperature}℃</span></Col>
            </Row>
            <Row>
              <Col span={2}><span>质检人员:</span></Col>
              <Col span={6}><span>姓名:</span><span>{info?.base_info?.warehouse_name}</span></Col>
              <Col span={6}><span>电话:</span><span>{info?.base_info?.warehouse_phone}</span></Col>
              <Col span={6}><span>职位:</span><span>{info?.base_info?.warehouse_position}</span></Col>
            </Row>
            <Row>
              <Col span={2}><span>财务人员:</span></Col>
              <Col span={6}><span>姓名:</span><span>{info?.base_info?.finance_name}</span></Col>
              <Col span={6}><span>电话:</span><span>{info?.base_info?.finance_phone}</span></Col>
              <Col span={6}><span>职位:</span><span>{info?.base_info?.finance_position}</span></Col>
            </Row>
            <Row>
              <Col span={2}><span>销售代表:</span></Col>
              <Col span={6}><span>姓名:</span><span>{info?.base_info?.sales_name}</span></Col>
              <Col span={6}><span>电话:</span><span>{info?.base_info?.sales_phone}</span></Col>
              <Col span={6}><span>职位:</span><span>{info?.base_info?.sales_position}</span></Col>
            </Row>
            <div className='quality-report-title'>到货商品信息</div>
            <Table
              className='quality-table'
              bordered
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              rowKey='sale_id'
              summary={() => {
                const { standard_numbers_check, standard_numbers, actual_numbers, actual_numbers_check } = computedSource;
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}>合计</Table.Summary.Cell>
                      <Table.Summary.Cell index={4}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}>{standard_numbers_check ? standard_numbers + '箱' : ''}</Table.Summary.Cell>
                      <Table.Summary.Cell index={2}></Table.Summary.Cell>
                      <Table.Summary.Cell index={3}>{actual_numbers_check ? actual_numbers + '箱' : ''}</Table.Summary.Cell>
                      <Table.Summary.Cell index={4}></Table.Summary.Cell>
                      <Table.Summary.Cell index={5}>{computedSource?.deviation}</Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
            <Row style={{ marginTop: 20 }}>
              <Col span={12}>
                <Col span={7}><span>集装箱内部湿度:</span><span>{info?.container_info?.box_in_humidity}%</span></Col>
                <Index list={info?.container_info?.box_in_humidity_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <Col span={4}><span>纸箱状况:</span><span>{info?.container_info?.carton_condition_type}</span></Col>
                <Col span={4}><span>数量:</span><span>{info?.container_info?.carton_condition_number}箱</span></Col>
                <Index list={info?.container_info?.carton_condition_number_pic || []} type='image' preview={showModal} />
                <Index list={info?.container_info?.carton_condition_number_video || []} type='video' preview={showModal} />
              </Col>
              <Col span={12}>
                <div>纸箱包装贴纸:</div>
                <Index list={info?.carton_packaging?.carton_packaging_sticker_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <div>果把贴码:</div>
                <Index list={info?.fruit_handle?.fruit_handle_sticker_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <div className='quality-report-title'>到货开柜</div>
            <Row>
              <Col span={24}><span style={{ color: 'D60505' }}>对于大型卡车，以集装箱仪器显示的设置温度、出风温度和回风温度为准。</span></Col>
              <Col span={24}><span style={{ color: 'D60505' }}>对于小型卡车，以车辆显示的设置温度作为设置温度和出风温度处，制冷装置(冷机显示屏)上显示的温度为回风温度。</span></Col>
              {/* <Col span={12}>
                <span>开柜时间:{info?.container_info?.container_time && moment(info?.container_info?.container_time).format(formatType)}</span>
                <Index list={info?.container_info?.container_pic || []} type='image' preview={showModal} />
              </Col> */}
              <Col span={12}>
                <span>出风温度:</span><span>{info?.container_info?.outlet_temperature}℃</span>
                <Index list={info?.container_info?.outlet_temperature_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <span>回风温度:</span><span>{info?.container_info?.return_air_temperature}℃</span>
                <Index list={info?.container_info?.return_air_temperature_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>风口:</span>
                <Index list={info?.container_info?.air_temperature_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row><Col span={24}><span>测量 3 个柜内温度（前部、中部、尾部采样于卸货处）：</span></Col></Row>
            <Row>
              <Col span={12}>
                <span>柜头:</span><span>{info?.container_info?.container_temperature_head}℃</span>
                <Index list={info?.container_info?.container_temperature_head_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>柜中:</span><span>{info?.container_info?.container_temperature_middle}℃</span>
                <Index list={info?.container_info?.container_temperature_middle_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <span>柜尾:</span><span>{info?.container_info?.container_temperature_end}℃</span>
                <Index list={info?.container_info?.container_temperature_end_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>平均温度:</span><span>{computed_container_temperature_average()}℃</span>
              </Col>
            </Row>
            <Row><Col span={24}><span>测量 3 个果肉心温度（请注意尽量使用运输过程中测量的果实，以避免损坏更多果实）：</span></Col></Row>
            <Row>
              <Col span={12}>
                <span>果心1:</span><span>{info?.container_info?.core_temperature1}℃</span>
                <Index list={info?.container_info?.core_temperature1_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>果心2:</span><span>{info?.container_info?.core_temperature2}℃</span>
                <Index list={info?.container_info?.core_temperature2_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <span>果心3:</span><span>{info?.container_info?.core_temperature3}℃</span>
                <Index list={info?.container_info?.core_temperature3_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>平均温度:</span><span>{computed_core_temperature_average()}℃</span>
              </Col>
            </Row>
            <Row><Col span={24}><span>IOT编号及温度</span></Col></Row>
            <Row>
              <Col span={12}>
                <span>IOT1编码:</span><span>{info?.container_info?.IOT1_no}</span>
                <span>温度:</span><span>{info?.container_info?.IOT1_no_temperature}℃</span>
                <Index list={info?.container_info?.IOT1_no_temperature_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>IOT2编码:</span><span>{info?.container_info?.IOT2_no}</span>
                <span>温度:</span><span>{info?.container_info?.IOT2_no_temperature}℃</span>
                <Index list={info?.container_info?.IOT2_no_temperature_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <span>IOT3编码:</span><span>{info?.container_info?.IOT3_no}</span>
                <span>温度:</span><span>{info?.container_info?.IOT3_no_temperature}℃</span>
                <Index list={info?.container_info?.IOT3_no_temperature_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            {/* <Row>
              <Col span={24}>
                <span>箱内温度:</span><span>{info?.container_info?.box_in_temperature}℃</span>
                <Index list={info?.container_info?.box_in_temperature_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <span>果心温度:</span><span>{info?.container_info?.core_temperature}℃</span>
                <Index list={info?.container_info?.core_temperature_pic || []} type='image' preview={showModal} />
              </Col>
            </Row> */}
            <Row>
              <Col span={7}><span>香气:</span><span>{info?.container_info?.container_taste}</span></Col>
              <Col span={12}><span>具体说明:</span><span>{info?.container_info?.container_taste_desc}</span></Col>
            </Row>
            {/* <Row>
              <Col span={7}><span>开柜味道:</span><span>{info?.container_info?.container_taste}</span></Col>
            </Row> */}
            <div className='quality-report-title'>抽样质检</div>
            <Row>
              <Col span={2}><span>抽样:</span><span>{info?.sample_info?.sample_number}箱</span></Col>
              <Col span={2}><span>共计:</span><span>{total_number}个</span></Col>
              <Col span={6}><span>占比:</span><span>{sample_number_percent}</span></Col>
            </Row>
            <Table
              className='quality-table'
              bordered
              dataSource={dataSource}
              columns={columns2}
              pagination={false}
              rowKey='sale_id'
            />
            <div className='quality-report-title'>单件称重</div>
            {(info?.weight_data || []).map((item, idx) => (
              <div key={idx} style={{ marginBottom: 20 }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={6}>
                    <span style={{ marginLeft: 8 }}>单位重量 {item?.base_factor}kg</span>
                  </Col>
                  <Col span={6}>
                    称重箱数 <span style={{ marginLeft: 8 }}>{item?.weight_number}箱</span>
                  </Col>
                </Row>
                <Table
                  className='quality-table'
                  bordered
                  dataSource={item?.weight_source || []}
                  columns={columns3}
                  pagination={false}
                  rowKey={(record) => record.position}
                />
              </div>
            ))}
            {/* <Row>
              <Col span={7}><span>称重图片:</span></Col>
              <Index list={info?.weight_info?.weight_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>平均毛重:</span><span>{average_weight}kg</span></Col>
              <Col span={7}><span>包装重:</span><span>{package_weight}kg</span></Col>
              <Col span={7}><span>平均净重:</span><span>{average_net_weight}kg</span></Col>
            </Row>
            <Row>
              <Col span={7}><span>标准净重:</span><span>{standardWeight}kg</span></Col>
              <Col span={7}><span>偏差:</span><span>{weight_deviation}kg</span></Col>
              <Col span={7}><span>偏差占比:</span><span>{weight_deviation_percent} %</span></Col>
            </Row>
            <Row>
              <Col span={7}><span>是否达标:</span><span>{[info?.weight_info?.is_standard]}</span></Col>
              <Col span={8}></Col>
              <Col span={8}></Col>
            </Row> */}
            <div className='quality-report-title'>果形</div>
            <Row>
              <Col span={7}><span>{info?.fruit_shape?.poor_fruit_shape}</span><span>{info?.fruit_shape?.poor_fruit_shape_number}个</span></Col>
              <Col span={7}><span style={{ marginLeft: 20 }}>占比:</span><span>{poor_fruit_shape_number_percent}%</span></Col>
              <Col span={7}><span style={{ marginLeft: 20 }}>描述:</span><span>{info?.fruit_shape?.poor_fruit_shape_describe}</span></Col>
              <Index list={info?.fruit_shape?.poor_fruit_shape_number_pic || []} type='image' preview={showModal} />
            </Row>
            <div className='quality-report-title'>房数</div>
            <Row>
              <Col span={7}><span>{info?.fruit_shape?.fruit_house}</span></Col>
              <Col span={7}><span>总计:</span><span>{info?.fruit_shape?.poor_fruit_shape_number}个</span></Col>
              <Col span={7}><span style={{ marginLeft: 20 }}>占比:</span><span>{fruit_house_number_percent}%</span></Col>
              <Col span={7}><span>{info?.fruit_shape?.fruit_house}</span></Col>
              <Col span={7}><span>{info?.fruit_shape?.fruit_house}</span></Col>
            </Row>
            <Index list={info?.fruit_shape?.fruit_house_shape_number_pic || []} type='image' preview={showModal} />
            <Row>
              <Col span={7}><span>3房:</span><span>{info?.fruit_shape?.fruit_house_number_3}个</span></Col>
              <Col span={7}><span>占比:</span><span>{fruit_house_number_3_percent}%</span></Col>
              <Index list={info?.fruit_shape?.fruit_house_shape_number_3_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>3.5房:</span><span>{info?.fruit_shape?.fruit_house_number_35}个</span></Col>
              <Col span={7}><span>占比:</span><span>{fruit_house_number_35_percent}%</span></Col>
              <Index list={info?.fruit_shape?.fruit_house_shape_number_35_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>4房及以上:</span><span>{info?.fruit_shape?.fruit_house_number_4}个</span></Col>
              <Col span={7}><span>占比:</span><span>{fruit_house_number_4_percent}%</span></Col>
              <Index list={info?.fruit_shape?.fruit_house_shape_number_4_pic || []} type='image' preview={showModal} />
            </Row>
            <div className='quality-report-title'>果柄</div>
            <Row>
              <Col span={7}><span>{info?.fruit_stalk?.fruit_stalk_type}</span></Col>
            </Row>
            <Row>
              <Col span={7}><span>断柄:</span><span>{info?.fruit_stalk?.fruit_stalk_broken}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_stalk_broken_percent()}%</span></Col>
              <Index list={info?.fruit_stalk?.fruit_stalk_broken_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>少柄:</span><span>{info?.fruit_stalk?.fruit_stalk_lacking}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_stalk_lacking_percent()}%</span></Col>
              <Index list={info?.fruit_stalk?.fruit_stalk_lacking_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>烂柄:</span><span>{info?.fruit_stalk?.fruit_stalk_rotten}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_stalk_rotten_percent()}%</span></Col>
              <Index list={info?.fruit_stalk?.fruit_stalk_rotten_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>总计:</span><span>{computed_fruit_stalk_number()}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_stalk_number_percent()}%</span></Col>
            </Row>
            <div className='quality-report-title'>颜色</div>
            {/* <Row>
              <Col span={7}><span>整体果色:</span><span>{(info?.colour_info?.fruit_color || []).map(item => `${item}   `)}</span></Col>
              <Col span={7}><span>描述:</span><span>{info?.colour_info?.colour_info_describe}</span></Col>
            </Row> */}
            <Row>
              <Col span={7}><span>1号色:</span><span>{info?.colour_info?.fruit_color_1}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_color_1_percent()}%</span></Col>
              <Index list={info?.colour_info?.fruit_color_1_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>2号色:</span><span>{info?.colour_info?.fruit_color_2}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_color_2_percent()}%</span></Col>
              <Index list={info?.colour_info?.fruit_color_2_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>3号色:</span><span>{info?.colour_info?.fruit_color_3}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_color_3_percent()}%</span></Col>
              <Index list={info?.colour_info?.fruit_color_3_pic || []} type='image' preview={showModal} />
            </Row>
            <Row>
              <Col span={7}><span>4号色:</span><span>{info?.colour_info?.fruit_color_4}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_color_4_percent()}%</span></Col>
              <Index list={info?.colour_info?.fruit_color_4_pic || []} type='image' preview={showModal} />
            </Row>
            <div className='quality-report-title'>果皮缺陷</div>
            <Row>
              <Col span={7}><span>{info?.colour_info?.fruit_peel_type}</span></Col>
            </Row>
            <Row>
              <Col span={7}><span>红刺果:</span><span>{info?.colour_info?.red_thorn_fruit}个</span><span style={{ marginLeft: 20 }}>占比: {red_thorn_fruit_percent}%</span></Col>
              <Col span={7}><span>褐色果:</span><span>{info?.colour_info?.brown_fruit}个</span><span style={{ marginLeft: 20 }}>占比: {brown_fruit_percent}%</span></Col>
              <Col span={7}><span>全清果:</span><span>{info?.colour_info?.whole_green_fruit}个</span><span style={{ marginLeft: 20 }}>占比: {whole_green_fruit_percent}%</span></Col>
              <Col span={7}><span>其他果:</span><span>{info?.colour_info?.other_fruit}个</span><span style={{ marginLeft: 20 }}>占比: {other_fruit_percent}%</span></Col>
            </Row>
            <Row>
              <Col span={7}><span>总计:</span><span>{computed_fruit_peel_number()}个</span></Col>
              <Col span={7}><span>占比:</span><span>{computed_fruit_peel_number_percent()}%</span></Col>
            </Row>
            {/* <div className='quality-report-title'>果壳</div> */}
            <div className='quality-report-title'>果壳 外部问题</div>
            {/* <Row>
              <Col span={12}>
                <span>果壳硬度:</span><span>{info?.shuck_info?.hardness_fruit}</span>
                <Index list={info?.shuck_info?.hardness_fruit_video || []} type='video' preview={showModal} />
              </Col>
            </Row> */}
            <Row>
              <Col span={12}>
                <span>{info?.shuck_info?.fruit_shell_type}</span>
              </Col>
            </Row>
            <div>果壳表面损坏</div>
            <div style={{ border: '1px solid #efefef', padding: '10px', margin: '10px 10px 30px' }}>
              <div>其中：</div>
              <Row>
                <Col span={8}><span>虫眼:</span><span>{info?.shuck_info?.wormhole_fruit}个</span><span style={{ marginLeft: 20 }}>占比{wormhole_fruit_percent}%</span>
                  <Index list={info?.shuck_info?.wormhole_fruit_pic || []} type='image' preview={showModal} />
                </Col>
                <Col span={8}><span>烂丁/烂刺/烂疤:</span><span>{info?.shuck_info?.rotten_fruit}个</span><span style={{ marginLeft: 20 }}>占比{rotten_fruit_percent}%</span>
                  <Index list={info?.shuck_info?.rotten_fruit_pic || []} type='image' preview={showModal} />
                </Col>
                <Col span={8}><span>发霉:</span><span>{info?.shuck_info?.shuck_other_fruit}个</span><span style={{ marginLeft: 20 }}>占比{shuck_other_fruit_percent}%</span>
                  <Index list={info?.shuck_info?.shuck_other_fruit_pic || []} type='image' preview={showModal} />
                </Col>
              </Row>
              <Row>
                <Col span={7}><span>总计:</span><span>{computed_shuck_other_fruit_number()}个</span></Col>
                <Col span={7}><span>占比:</span><span>{computed_shuck_other_fruit_number_percent()}%</span></Col>
              </Row>
            </div>
            <div>裂口</div>
            <div  style={{ border: '1px solid #efefef', padding: '10px', margin: '10px 10px 30px' }}>
            <div>单果开裂程度超过轴线高度的30%且能看到果肉</div>
              <Row>
                <Col span={8}><span>开裂长度小于30%:</span><span>{info?.shuck_info?.cleft_fruit_low}个</span><span style={{ marginLeft: 20 }}>占比{(isPureNumber(total_number) && isPureNumber(info?.shuck_info?.cleft_fruit_low) && Number(info?.shuck_info?.cleft_fruit_low) > 0) ? (Number(info?.shuck_info?.cleft_fruit_low) * 100 / total_number).toFixed(2) : ''}%</span>
                  <Index list={info?.shuck_info?.cleft_fruit_low_pic || []} type='image' preview={showModal} />
                </Col>
                <Col span={8}><span>开裂长度30%-50%:</span><span>{info?.shuck_info?.cleft_fruit_middle}个</span><span style={{ marginLeft: 20 }}>占比{(isPureNumber(total_number) && isPureNumber(info?.shuck_info?.cleft_fruit_middle) && Number(info?.shuck_info?.cleft_fruit_middle) > 0) ? (Number(info?.shuck_info?.cleft_fruit_middle) * 100 / total_number).toFixed(2) : ''}%</span>
                  <Index list={info?.shuck_info?.cleft_fruit_middle_pic || []} type='image' preview={showModal} />
                </Col>
                <Col span={8}><span>开裂长度大于50%:</span><span>{info?.shuck_info?.cleft_fruit_high}个</span><span style={{ marginLeft: 20 }}>占比{(isPureNumber(total_number) && isPureNumber(info?.shuck_info?.cleft_fruit_high) && Number(info?.shuck_info?.cleft_fruit_high) > 0) ? (Number(info?.shuck_info?.cleft_fruit_high) * 100 / total_number).toFixed(2) : ''}%</span>
                  <Index list={info?.shuck_info?.cleft_fruit_high_pic || []} type='image' preview={showModal} />
                </Col>
              </Row>
              <Row>
                <Col span={7}><span>总计:</span><span>{computed_cleft_fruit_number()}个</span></Col>
                <Col span={7}><span>占比:</span><span>{computed_cleft_fruit_number_percent()}%</span></Col>
              </Row>
            </div>
            <div className='quality-report-title'>内部问题</div>
            <Row>
              <Col span={8}><span>{info?.shuck_info?.fruit_shell_in_type}</span></Col>
            </Row>
            <Row>
              <Col span={12}>
                <span>生果:</span><span>{info?.shuck_info?.bear_fruit}个</span><span style={{ marginLeft: 20 }}>占比: {bear_fruit_percent}% </span>
                <Index list={info?.shuck_info?.bear_fruit_pic || []} type='image' preview={showModal} />
                <Index list={info?.shuck_info?.bear_fruit_video || []} type='video' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>死包:</span><span>{info?.shuck_info?.dead_fruit}个</span><span style={{ marginLeft: 20 }}>占比: {dead_fruit_percent}%</span>
                <Index list={info?.shuck_info?.dead_fruit_pic || []} type='image' preview={showModal} />
                <Index list={info?.shuck_info?.dead_fruit_video || []} type='video' preview={showModal} />
              </Col>
            </Row>
            <div className='quality-report-title'>果肉</div>
            <Row><Col span={12}><span>{info?.shuck_info?.fruit_flesh_type}</span></Col></Row>
            <Row>
              <Col span={12}>
                <span>腐烂:</span><span>{info?.shuck_info?.fruit_flesh_rot}个</span><span style={{ marginLeft: 20 }}>占比: {computed_fruit_flesh_rot_percent()}% </span>
                <Index list={info?.shuck_info?.fruit_flesh_rot_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>疫病菌:</span><span>{info?.shuck_info?.fruit_flesh_blight}个</span><span style={{ marginLeft: 20 }}>占比: {computed_fruit_flesh_blight_percent()}%</span>
                <Index list={info?.shuck_info?.fruit_flesh_blight_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <span>虫果:</span><span>{info?.shuck_info?.fruit_flesh_wormy}个</span><span style={{ marginLeft: 20 }}>占比: {computed_fruit_flesh_wormy_percent()}% </span>
                <Index list={info?.shuck_info?.fruit_flesh_wormy_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>烧核:</span><span>{info?.shuck_info?.fruit_flesh_burning}个</span><span style={{ marginLeft: 20 }}>占比: {computed_fruit_flesh_burning_percent()}%</span>
                <Index list={info?.shuck_info?.fruit_flesh_burning_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row>
              <Col span={12}><span>总计:</span><span>{computed_fruit_flesh_number()}</span></Col>
              <Col span={12}><span>占比:</span><span>{(() => {
                if (isPureNumber(total_number) && isPureNumber(computed_fruit_flesh_number()) && Number(computed_fruit_flesh_number()) > 0) {
                  return (Number(computed_fruit_flesh_number()) * 100 / total_number).toFixed(2);
                }
                return '';
              })()}%</span></Col>
            </Row>
            <div className='quality-report-title'>糖度</div>
            <Row>
              <Col span={8}><span>{info?.flesh_info?.sugar_sampling_type}</span></Col>
            </Row>
            {SugarSamplingDisplay(info, showModal)}
            <Row><Col span={8}><span>平均糖度:</span><span>{computed_average_sugar()}%Brix</span></Col></Row>
            <div className='quality-report-title'>果肉</div>
            <Row>
              <Col span={8}><span>果肉颜色:</span><span>{info?.flesh_info?.flesh_color}</span><Index list={info?.flesh_info?.flesh_color_pic || []} type='image' preview={showModal} /></Col>
              <Col span={8}><span>口感:</span><span>{info?.flesh_info?.flesh_taste}</span></Col>
            </Row>

            {/* <Row>
              <Col span={12}>
                <span>青榴莲:</span><span>{info?.shuck_info?.durian_fruit}个</span>
                <span style={{ marginLeft: 20 }}>占比: {durian_fruit_percent}%</span>
                <span style={{ marginLeft: 20 }}>描述:</span><span>{info?.shuck_info?.durian_fruit_describe}</span>
                <Index list={info?.shuck_info?.durian_fruit_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>果壳表面损坏:</span><span>{info?.shuck_info?.damage_fruit}个</span><span style={{ marginLeft: 20 }}>占比: {damage_fruit_percent} %</span>
                <span style={{ marginLeft: 20 }}>描述:</span><span>{info?.shuck_info?.damage_fruit_describe}</span>
                <Index list={info?.shuck_info?.damage_fruit_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <span>裂口:</span><span>{info?.shuck_info?.cleft_fruit}个</span><span style={{ marginLeft: 20 }}>占比{cleft_fruit_percent}%</span>
                <Index list={info?.shuck_info?.cleft_fruit_pic || []} type='image' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>成熟度:</span><span>{(info?.shuck_info?.maturity || []).map(item => `${item}    `)}</span><span></span>
                <span style={{ marginLeft: 20 }}>描述：{info?.shuck_info?.shuck_info_describe}</span>
              </Col>
            </Row>
            <div className='quality-report-title'>果肉</div>
            <Row>
              <Col span={12}>
                <span>果肉硬度:</span><span>{info?.flesh_info?.hardness_flesh}</span>
                <Index list={info?.flesh_info?.hardness_flesh_video || []} type='video' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>糖度检测抽样:</span><span>{info?.flesh_info?.sugar_sampling}个</span>
                <span style={{ marginLeft: 20 }}>平均糖度:</span><span>{info?.flesh_info?.average_sugar}%</span>
                <Index list={info?.flesh_info?.average_sugar_pic || []} type='image' preview={showModal} />
              </Col>
            </Row>
            <Row>
              <span>果肉颜色:</span><span>{info?.flesh_info?.flesh_color}</span>
              <span style={{ marginLeft: 20 }}>口感:</span><span>{info?.flesh_info?.flesh_taste}</span>
            </Row> */}
            <div className='quality-report-title'>其他记录</div>
            <Row>
              <Col span={12}>
                <span>质检现场</span>
                <Index list={info?.other_info?.inspection_scene_pic || []} type='image' preview={showModal} />
                <Index list={info?.other_info?.inspection_video || []} type='video' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>质检过程</span>
                <Index list={info?.other_info?.inspection_process_pic || []} type='image' preview={showModal} />
                <Index list={info?.other_info?.inspection_process_video || []} type='video' preview={showModal} />
              </Col>
              <Col span={12}>
                <span>质检卡图片</span>
                <Index list={info?.other_info?.inspection_pic || []} type='image' preview={showModal} />
                <Index list={info?.other_info?.inspection_card_video || []} type='video' preview={showModal} />
              </Col>
            </Row>
            <div className='quality-report-title'>买方意见</div>
            <div>{info?.buy_comments}</div>
            {
              (String(info?.status) === '3') ? <>
                <div className='quality-report-title'>卖方处理意见</div>
                {+info?.handling_opinions === 0 && info?.sale_comments.trim() === '' ? <div>-</div> :
                  <>
                    <div style={{ whiteSpace: 'pre-wrap' }} >{info?.sale_comments}</div>
                  </>
                }
              </> : null
            }
          </div>
        </> : <Spin tip="Loading..."></Spin>
      }
    </div>
  );
};